export const AppleIcon = ({ className }: { className?: string }) => (
  <svg
    width='14'
    height='17'
    viewBox='0 0 14 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <g clipPath='url(#clip0_449_3037)'>
      <path
        d='M4.47195 16.0988C4.3037 16.0988 4.13545 16.0988 3.9672 16.0988C3.49788 15.9748 3.09054 15.7269 2.75404 15.3815C2.06333 14.6731 1.52316 13.8584 1.07155 12.9818C0.549088 11.9634 0.2303 10.8831 0.079761 9.74077C-0.0265016 8.91723 -0.0353568 8.0937 0.168313 7.27902C0.45168 6.14555 1.01841 5.18033 2.0102 4.5339C2.75404 4.04686 3.57757 3.79006 4.47195 3.97602C5.00326 4.08228 5.52572 4.29481 6.03047 4.48077C6.43781 4.63131 6.82744 4.65787 7.23478 4.48962C7.59784 4.32137 7.97862 4.1974 8.35939 4.07343C9.62569 3.67494 10.8123 3.88747 11.9015 4.6136C12.2291 4.83498 12.4948 5.13605 12.7162 5.48141C11.503 6.25181 10.9008 7.31444 10.9982 8.76669C11.1045 10.2189 11.8749 11.193 13.1501 11.804C13.1324 11.866 13.1146 11.9103 13.0969 11.9546C12.6896 13.1323 12.0432 14.1595 11.2639 15.1159C10.9628 15.4878 10.6175 15.8066 10.157 15.9571C9.9799 16.0191 9.78508 16.0457 9.59027 16.0811C9.55485 16.0811 9.52828 16.0811 9.49286 16.0811C9.37774 16.0634 9.25377 16.0634 9.13865 16.028C8.75788 15.9129 8.36825 15.7977 7.99633 15.6561C7.47387 15.4701 6.94256 15.3461 6.40239 15.4878C5.75596 15.6738 5.10953 15.8951 4.47195 16.0988Z'
        fill='#007CFF'
      />
      <path
        d='M6.5529 3.69263C6.41122 1.62051 8.18226 0.106263 9.7762 0C9.82048 0.309933 9.80277 0.619865 9.74078 0.929798C9.5194 1.98357 8.9261 2.78939 8.03172 3.36498C7.58896 3.65721 7.09307 3.74576 6.5529 3.69263Z'
        fill='#007CFF'
      />
    </g>
    <defs>
      <clipPath id='clip0_449_3037'>
        <rect width='13.15' height='16.0988' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
